/**
 * Hoe ver we met een kansje zijn (MA-51).
 *
 * Alleen een kansje heeft een fase; bij elk ander oordeel is hij null. Wie een
 * woning kansje maakt, zet hem op `gescout`, en wie hem terugdraait naar bekeken
 * of afkeurt, gooit de fase weg: wordt hij later opnieuw kansje, dan begint hij
 * weer vooraan. Net als het oordeel is de fase van ons en niet van de bron, dus
 * de import raakt hem niet aan.
 */
import { z } from 'zod';

export const FASEN = [
  'gescout',
  'taxatie',
  'shanghai',
  'bezichtigen',
  'bieding',
  'geaccepteerd',
] as const;

export const faseSchema = z.enum(FASEN);
export type Fase = z.infer<typeof faseSchema>;

/** Waar een nieuw kansje begint. */
export const FASE_STANDAARD: Fase = 'gescout';

export const FASE_LABELS: Record<Fase, string> = {
  gescout: 'Gescout',
  taxatie: 'Taxatie',
  /** De laatste waardebepaling, na de taxatie. */
  shanghai: 'Shanghai',
  bezichtigen: 'Bezichtigen',
  bieding: 'Bieding',
  geaccepteerd: 'Bod geaccepteerd',
};
